<template>
  <!-- 图片预览 -->
  <el-dialog
    :title="fileDialog.fileName"
    top="3vh"
    width="70%"
    class="file_dialog"
    :visible.sync="fileDialog.visible"
    v-dialogDrag
  >
    <img
      :src="
        fileDialog.previewVersionTag === 0 ? 'static/img/gz/在用.png' : 'static/img/gz/弃用.png'
      "
      alt
      v-if="versionManagement === 'true'"
      class="position-absolute"
      style="right: 10px; top: 65px;"
    />
    <p v-if="fileDialog.fileType === 'pdf'" class="height-20 fz-14 has-text-right text-color-blue">
      操作提示：Ctrl + 鼠标滚轮中键 可放大缩小
    </p>
    <iframe
      v-if="fileDialog.fileType === 'wizdrawing'"
      ref="htFrame"
      :src="fileDialog.resourceUrl"
      width="100%"
      height="800px"
      class="myiframe"
      allowfullscreen
      @load="htLoad"
    ></iframe>
    <iframe
      :src="fileDialog.resourceUrl"
      width="100%"
      height="800px"
      v-else-if="fileDialog.fileType !== 'svg'"
      allowfullscreen
      allow="autoplay"
      class="myiframe"
    ></iframe>
    <iframe
      width="100%"
      height="800px"
      v-else-if="fileDialog.fileType === 'svg'"
      id="previewSvg"
      :src="fileDialog.resourceUrl"
    ></iframe>
  </el-dialog>
</template>

<script>
export default {
  props: {
    fileDialog: {
      type: Object,
      default: () => {
        return {
          fileType: '',
          fileName: '',
          previewVersionTag: '',
          visible: false,
          resourceUrl: '',
        }
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    versionManagement() {
      const version = _.find(this.systemParams, { parameterCode: 'versionManagement' }) || {}
      return version.parameterValue
    },
    systemParams() {
      return this.$store.getters.systemParams || []
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
